export const disneyQuotes = [
  
  {
    id: 1,
    name: 'Yoda',
    category: 'Star Wars',
    quote: 'Che la connessione sia con te!',
  },
 
  {
    id: 2,
    name: 'Iron Man',
    category: 'Marvel',
    quote: 'I limiti sono fatti per essere superati!'
  },
  {
    id: 3,
    name: 'Peter Pan',
    category: 'Classic',
    quote: 'Non smettete mai di sognare, solo chi sogna può volare'
  },
  {
    id: 4,
    name: 'Lilly e il Vagabondo',
    category: 'Classic',
    quote: 'Le auguro una BELLA NOTTE!'
  },
  {
    id: 5,
    name: 'Fata Madrina',
    category: 'Classic',
    quote: 'BIBIDIBOBIDIBU! Fatto!'
  },
  {
    id: 6,
    name: 'Il Libro della Giungla',
    category: 'Classic',
    quote: 'le chiederò LO STRETTO INDISPENSABILE!'
  },
  {
    id: 7,
    name: 'Fata Madrina',
    category: 'Classic',
    quote: `..anche per i miracoli c'è bisogno di un pò di tempo`
  },
  {
    id: 8,
    name: 'Anacleto',
    category: 'Classic',
    quote: 'QUISQUILIE E PINZILLACCHERE!'
  },
  {
    id: 9,
    name: 'Timon e Pumba',
    category: 'Classic',
    quote: 'HAKUNA MATATA!'
  },
  {
    id: 10,
    name: 'Toy Story',
    category: 'Pixar',
    quote: 'VERSO L’INFINITO E OLTRE!'
  },
  {
    id: 11,
    name: 'Mary Poppins',
    category: 'Classic',
    quote: 'SUPER CALIFRAGILISTI CHE SPIRALIDOSO!'
  },
  {
    id: 12,
    name: 'Ratatouille',
    category: 'Pixar',
    quote: 'Posso parlare con mamma/papà PICCOLO CHEF?'
  },
  {
    id: 13,
    name: 'Re Leone',
    category: 'Classic',
    quote: `(il film che cerchi) UN GIORNO ......SARA’ TUO!`
  },
  {
    id: 14,
    name: 'Yoda',
    category: 'Star Wars',
    quote: `Saperne un po' di più può illuminarci la via.`
  },
  {
    id: 15,
    name: 'Qui-Gon Jinn',
    category: 'Star Wars',
    quote: `Tutto sistemato mio giovane PADAWAN`
  },
  {
    id: 16,
    name: 'Hulk',
    category: 'Marvel',
    quote: `Puoi passarmi mamma o papà, piccolo umano?`
  },

 ];
